/**
 * Minimal, typed localisation. A dictionary is a flat map of dotted keys, which
 * keeps `keyof` exact — a missing or misspelled key is a compile error, and the
 * Russian dictionary cannot drift from the English one.
 *
 * Plural forms are selected with `Intl.PluralRules`, so Russian gets its three
 * forms (одна проверка / две проверки / пять проверок) without hand-rolled rules.
 */
export interface PluralForms {
  one: string;
  few?: string;
  many?: string;
  other: string;
}

export type Message = string | PluralForms;

export const LOCALES = ['en', 'ru'] as const;
export type Locale = (typeof LOCALES)[number];

/** Locale tags used for dates, numbers and plural rules. */
export const INTL_LOCALES: Record<Locale, string> = {
  en: 'en-GB',
  ru: 'ru-RU',
};

export const LOCALE_NAMES: Record<Locale, string> = {
  en: 'English',
  ru: 'Русский',
};

export type TranslateVars = Record<string, string | number>;
